import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CHARGER_STATE = createActionTypes('FETCH_CHARGER_STATE');
export const GET_CHARGER_STATE = createActionTypes('GET_CHARGER_STATE');
export const CREATE_CHARGER_STATE = createActionTypes('CREATE_CHARGER_STATE');
export const UPDATE_CHARGER_STATE = createActionTypes('UPDATE_CHARGER_STATE');
export const DELETE_CHARGER_STATE = createActionTypes('DELETE_CHARGER_STATE');
